export default __webpack_public_path__ + "static/media/range-1.1a6a5926.png";